export interface FeatureFlags {
  offlineCache: boolean;
  keyboardShortcuts: boolean;
  whatsNewModal: boolean;
}

const FEATURE_FLAG_DEFAULTS: FeatureFlags = {
  offlineCache: true,
  keyboardShortcuts: true,
  whatsNewModal: true,
};

const parseBoolean = (value: string | boolean | undefined, fallback: boolean) => {
  if (typeof value === "boolean") return value;
  if (typeof value === "string") {
    return ["true", "1", "yes", "on"].includes(value.toLowerCase());
  }
  return fallback;
};

export const buildFeatureFlags = (
  env: Record<string, any> = import.meta.env,
  overrides: Partial<FeatureFlags> = {}
): FeatureFlags => {
  const fromEnv: FeatureFlags = {
    offlineCache: parseBoolean(env.VITE_FLAG_OFFLINE_CACHE, FEATURE_FLAG_DEFAULTS.offlineCache),
    keyboardShortcuts: parseBoolean(env.VITE_FLAG_KEYBOARD_SHORTCUTS, FEATURE_FLAG_DEFAULTS.keyboardShortcuts),
    whatsNewModal: parseBoolean(env.VITE_FLAG_WHATS_NEW_MODAL, FEATURE_FLAG_DEFAULTS.whatsNewModal),
  };

  return {
    ...FEATURE_FLAG_DEFAULTS,
    ...fromEnv,
    ...overrides,
  };
};

export const featureFlagDefaults = FEATURE_FLAG_DEFAULTS;
